export default __webpack_public_path__ + "static/media/Pet Fleet Cinder Fu Dog.7b80793b.jpg";